import React, { useRef, useState } from 'react'
import { Button } from 'antd';
import { AudioFilled, SoundOutlined } from '@ant-design/icons';

export default function AudioRecorder({message, setMessage, small}) {
    const [recording, setRecording] = useState(false);
    const [listening, setListening] = useState(false);
    const [isDetectingSound, setIsDetectingSound] = useState(false);
    const mediaRecorder = useRef(null);
    const audioChunks = useRef([]);
    const audioContext = useRef(null);
    const analyser = useRef(null);
    const source = useRef(null);
    const audioRef = useRef(new Audio());
    const threshold = 0.01;

    const startRecording = async () => {
        setMessage(null);
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorder.current = new MediaRecorder(stream);
        audioContext.current = new AudioContext();
        source.current = audioContext.current.createMediaStreamSource(stream);
        analyser.current = audioContext.current.createAnalyser();
        source.current.connect(analyser.current);
        detectSound();

        mediaRecorder.current.ondataavailable = (event) => {
            audioChunks.current.push(event.data);
        };

        mediaRecorder.current.onstop = () => {
            const audioBlob = new Blob(audioChunks.current, { type: "audio/wav" });
            setMessage(audioBlob);
            audioChunks.current = [];
            setIsDetectingSound(false);
        };

        mediaRecorder.current.start();
        setRecording(true);
    };

    const stopRecording = () => {
        mediaRecorder.current?.stop();
        setRecording(false);
    };

    const detectSound = () => {
        if (!analyser.current) return;
        const dataArray = new Uint8Array(analyser.current.fftSize);

        const checkSound = () => {
            analyser.current.getByteFrequencyData(dataArray);
            const volume = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;
            setIsDetectingSound(volume > threshold * 255);
            requestAnimationFrame(checkSound);
        };
        checkSound();
    };

    const playAduio = () => {
        if (message) {
            if (listening) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                setListening(false);
            } else {
                audioRef.current.src = URL.createObjectURL(message);
                audioRef.current.play();
                audioRef.current.onended = () => setListening(false);
                setListening(true);
            }

        }
    }

    return (
        <div className='text-center' style={{
            borderTop: "2px solid #e1e1e1",
            padding: 5,
            backgroundColor: "white",
        }}>
            <Button
                type='primary'
                danger={recording ? true : false}
                onClick={recording ? stopRecording : startRecording}
                style={{
                    fontSize: small ? 14 : 18,
                    height: "auto",
                    borderRadius: 10,
                    padding: "5px 20px",
                    width: 188,
                    margin: 3
                }}
            >
                <AudioFilled />
                {recording ? "Dừng ghi âm" : "Bắt đầu ghi âm"}
            </Button>
            {message && <Button
                danger={listening ? true : false}
                type={listening ? "primary" : ""}
                onClick={playAduio}
                style={{
                    fontSize: small ? 14 : 18,
                    height: "auto",
                    borderRadius: 10,
                    padding: "5px 20px",
                    margin: 3,
                    width: 157,
                }}>
                <SoundOutlined />
                {listening ? "Dừng nghe" : "Nghe lại"}
            </Button>}
        </div>
    );
}